export default __webpack_public_path__ + "static/media/E-commerce App.9a5a0efb.png";